var _a;
import $ from "jquery";
import "../../../public/style/baidu_map.css";
/**全局对象 */
var myWindow = window;
/**入口函数的原型 */
var main_prototype = (_a = myWindow.main) === null || _a === void 0 ? void 0 : _a.prototype;
// 执行入口函数
myWindow.main && myWindow.main();
/**表单 */
function init_form() {
    // 表单配置函数
    var get_form_options = main_prototype.get_form_options;
    // 表单元素
    var form = $(".location_details .form_container form");
    // 表单成员列表
    var input_list = $(".location_details .form_container form .field .input");
    // 提交表单时触发
    form.on("submit", function (e) {
        e.preventDefault();
        // 获取表单数据
        var data = form.serializeArray();
        var newdata = {};
        for (var i = 0; i < data.length; i++) {
            var item = data[i];
            newdata[item.name] = item.value;
        }
        var isPass = true;
        for (var i = 0; i < input_list.length; i++) {
            var item = input_list[i];
            if (JSON.stringify(item.dataset).includes("required")) {
                if (item.children[1]) {
                    var value = item.children[1].value;
                    if (!value) {
                        isPass = false;
                        var label = item.children[0].innerHTML;
                        alert("".concat(label, "\u4E0D\u80FD\u4E3A\u7A7A!"));
                    }
                }
            }
        }
        if (!get_form_options)
            return;
        /**表单配置 */
        var options = get_form_options(newdata);
        // 判断是否可以提交
        if (isPass) {
            if (options.method === "post") {
                $.post(options.url, newdata).then(function (res) {
                    options.succeed(res);
                }).catch(function (err) {
                    options.fail(err);
                });
            }
            else {
                $.get(options.url, newdata).then(function (res) {
                    options.succeed(res);
                }).catch(function (err) {
                    options.fail(err);
                });
            }
        }
    });
}
init_form();
// 清除入口函数
myWindow.main = undefined;
